import { useMutationToast } from '@ui/hooks/useMutationToast';
import { Nullable } from '@ui/types/utility';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { useDisconnect, useWatchAsset } from 'wagmi';

export const useAddTokenToWallet = ({
  tokenDisplaySymbol,
}: {
  tokenDisplaySymbol: Nullable<string>;
}) => {
  const mutationToastInfo = useMutationToast();
  const { t } = useTranslation();
  const { connectors } = useDisconnect();

  const { watchAsset, isPending } = useWatchAsset({
    mutation: {
      onMutate: () => {
        mutationToastInfo.onMutate({
          title: t('common.Adding Token {symbol} To {wallet}', {
            wallet: connectors.at(0)?.name,
            symbol: tokenDisplaySymbol,
          }),
          description: t('common.Please comfirm in your wallet while adding the token', {
          }),
        });
      },
      onSuccess: () => {
        mutationToastInfo.onSuccess({
          title: t('common.Added Token {symbol} To {wallet}', {
            wallet: connectors.at(0)?.name,
            symbol: tokenDisplaySymbol,
          }),
          description: t('common.Enjoy your trading now !'),
          action: undefined,
        });
      },
      onError: () => {
        mutationToastInfo.onError({});
      },
      onSettled: () => {
        mutationToastInfo.onSettled();
      },
    },
  });

  return useMemo(
    () => ({
      watchAsset,
      isPending,
    }),
    [isPending, watchAsset],
  );
};
